// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3qIha","label":"Section_label__3P73K","contentWrap":"Section_contentWrap__2CdAb","footer":"Section_footer__3uRKx","footerInner":"Section_footerInner__1iSnx"};